import styled from 'styled-components';
import { Table } from 'UI';
import { COLOR_WHITE, COLOR_LINK } from 'constants/colors';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLOR_WHITE};
  padding: 1.5rem;

  & > * {
    flex: 1;
  }
`;

export const ActionButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_LINK};
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const ProcessTable = styled(Table)`
  padding-top: 3rem;
`;
